import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useSocket } from 'cfgCommon/socketContext'
import { updateNotificationsList } from './redux/saveNotifications'
import { NOTIFICATION_SECTION, WHATSAPP_MESSAGES_EVENT_REASONS, WHATSAPP_CALLS_EVENT_REASONS } from './redux/constants'
import { BFFAgent } from 'BFFAgent'
import { toast } from 'react-toastify'
import Popover from '@material-ui/core/Popover'
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import Tooltip from '@material-ui/core/Tooltip'
import Switch from '@material-ui/core/Switch'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import NotificationItem from './NotificationItem'
import CallNotificationItem from './CallNotificationItem'
import Spinner from 'common/Spinner'
import ConfirmationModal from 'common/ConfirmationModal'
import { checkIsMobile } from 'Utilities'
import emptyBox from 'src/images/empty_box.svg'
import { ERROR_MESSAGES_TEXT } from 'common/Constants'

const TOOLTIP_TEXT = 'Notificaciones de WhatsApp'
const SHOW_UNREAD_ONLY_KEY = 'showUnreadOnlyWhatsapp'
const EMPTY_NOTIFICATIONS_MESSAGE_ALL = 'Cuando tengas notificaciones leídas las verás acá'
const EMPTY_NOTIFICATIONS_MESSAGE_UNREAD = 'Cuando tengas nuevas las verás acá'

const WHATSAPP_TAB = {
    MESSAGES: 'messages',
    CALLS: 'calls',
}

const EmptyNotificationsIcon = () => (
    <svg
        width="64"
        height="65"
        viewBox="0 0 64 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M58.0196 32.5002C58.0196 46.8703 46.3701 58.5198 31.9999 58.5198C17.6298 58.5198 5.98071 46.8703 5.98071 32.5002C5.98071 18.13 17.6298 6.48096 31.9999 6.48096C46.3701 6.48096 58.0196 18.13 58.0196 32.5002Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.5077 56.1753C44.8552 56.1753 55.6755 45.355 55.6755 32.0075C55.6755 18.6599 44.8552 7.83963 31.5077 7.83963C18.1602 7.83963 7.33988 18.6599 7.33988 32.0075C7.33988 45.355 18.1602 56.1753 31.5077 56.1753ZM31.5077 58.5921C46.19 58.5921 58.0923 46.6897 58.0923 32.0075C58.0923 17.3252 46.19 5.42285 31.5077 5.42285C16.8254 5.42285 4.9231 17.3252 4.9231 32.0075C4.9231 46.6897 16.8254 58.5921 31.5077 58.5921Z"
            fill="#908AAD"
        />
        <path
            d="M39.7551 21.8924L27.4938 35.3509L22.9412 30.3538L22.9401 30.3525C22.3506 29.7086 21.5375 29.3342 20.6752 29.3365C19.813 29.3388 19.0017 29.7175 18.4153 30.3643L18.9339 30.8345L18.4153 30.3643C17.8308 31.0089 17.5134 31.8692 17.5153 32.7533C17.5173 33.637 17.8383 34.4955 18.4254 35.1371C18.4256 35.1374 18.4258 35.1376 18.426 35.1378L25.1838 42.5554C25.184 42.5556 25.1842 42.5558 25.1844 42.556C25.4752 42.8767 25.8244 43.135 26.2139 43.3127L26.5044 42.6759L26.2139 43.3127C26.6039 43.4907 27.0247 43.5834 27.4516 43.5834C27.8785 43.5834 28.2993 43.4907 28.6893 43.3127C29.0788 43.135 29.4279 42.8767 29.7187 42.5561C29.7189 42.5559 29.7192 42.5556 29.7194 42.5554L44.5893 26.2336C44.5894 26.2335 44.5895 26.2334 44.5896 26.2332C44.8808 25.915 45.1091 25.5404 45.2642 25.1323C45.4193 24.724 45.499 24.2881 45.4999 23.8491C45.5009 23.4101 45.4231 22.9738 45.2699 22.5648C45.1166 22.1558 44.8899 21.7799 44.6 21.4601C44.3099 21.1402 43.9618 20.8823 43.5735 20.7045L43.283 21.3391L43.5735 20.7045C43.1849 20.5267 42.7656 20.4335 42.34 20.4323C41.9145 20.4312 41.4947 20.5222 41.1053 20.698C40.7161 20.8738 40.3667 21.1299 40.0752 21.4484L39.7206 21.8357L39.7551 21.8924Z"
            fill="#D3CBE3"
            stroke="#908AAD"
            strokeWidth="1.4"
        />
    </svg>
)

const CheckIcon = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_whatsapp_notification)">
            <path
                d="M7.50016 13.4998L4.00016 9.99984L2.8335 11.1665L7.50016 15.8332L17.5002 5.83317L16.3335 4.6665L7.50016 13.4998Z"
                fill="#2C872C"
            />
        </g>
        <defs>
            <clipPath id="clip0_whatsapp_notification">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

const StyledMenu = props => (
    <Popover
        elevation={2}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        PaperProps={{
            className: 'paper-whatsapp-notification',
            id: 'whatsapp-notifications',
        }}
        transitionDuration={{ enter: 0, exit: 200 }}
        marginThreshold={16}
        {...props}
    />
)

const WhatsAppNotificationMenu = ({
    closeSideMenu,
    forceCloseFlag,
    setForceCloseFlagFalse,
    onOpen,
}) => {
    const dispatch = useDispatch()
    const hasWhatsappBusinessApi = useSelector(
        state => state.common.user.license.hasWhatsappBusinessApi
    )
    const userId = useSelector(state => state.common.user.id)
    const shouldUpdateNotificationsList = useSelector(
        state => state.home.shouldUpdateNotificationsList
    )
    const { socket, SOCKET_EVENTS } = useSocket()
    const isMobile = checkIsMobile()
    const [anchorEl, setAnchorEl] = useState(null)
    const [showTooltip, setShowTooltip] = useState(false)
    const [notifications, setNotifications] = useState([])
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)
    const [badgeCount, setBadgeCount] = useState(0)
    const [unreadCount, setUnreadCount] = useState(0)
    const [readCount, setReadCount] = useState(0)
    const [badgeVisible, setBadgeVisible] = useState(true)
    const [forceShow, setForceShow] = useState(false)
    const [pendingData, setPendingData] = useState({})
    const [activeTab, setActiveTab] = useState(WHATSAPP_TAB.MESSAGES)
    const [showUnreadOnly, setShowUnreadOnly] = useState(true)
    const [callNotifications, setCallNotifications] = useState([])
    const [callsLoading, setCallsLoading] = useState(false)
    const [callsPage, setCallsPage] = useState(1)
    const [callsHasMore, setCallsHasMore] = useState(true)
    const [callsLoaded, setCallsLoaded] = useState(false)
    const whatsappIconRef = useRef(null)
    const isMobileSystem = useSelector(state => state.common.user.isMobileSystem)

    useEffect(() => {
        const savedShowUnreadOnly = localStorage.getItem(SHOW_UNREAD_ONLY_KEY)
        if (savedShowUnreadOnly !== null) {
            setShowUnreadOnly(savedShowUnreadOnly === 'true')
        }
    }, [])

    useEffect(() => {
        if (forceCloseFlag) {
            setAnchorEl(null)
            setForceCloseFlagFalse()
        }
    }, [forceCloseFlag])

    const initializeNotifications = useCallback((totalRead, totalUnread) => {
        setReadCount(totalRead)
        setUnreadCount(totalUnread)
        if (badgeVisible && totalUnread > 0) {
            setBadgeCount(totalUnread)
        }
    }, [badgeVisible])

    const getWhatsAppNotifications = useCallback(async (pageToLoad = 1, unreadOnly = true, eventReason = null) => {
        const response = await BFFAgent.Notifications.getNotifications(
            userId,
            pageToLoad,
            unreadOnly,
            NOTIFICATION_SECTION.WHATSAPP,
            eventReason
        )
        return response
    }, [userId])

    const getNotifications = useCallback(
        async (pageToLoad = 1, unreadOnly = showUnreadOnly) => {
            setLoading(true)
            try {
                const { notifications: notificationsResponse, totalRead, totalUnread } =
                    await getWhatsAppNotifications(pageToLoad, unreadOnly, WHATSAPP_MESSAGES_EVENT_REASONS)

                if (pageToLoad === 1) {
                    setNotifications(notificationsResponse)
                } else {
                    setNotifications(prev => [...prev, ...notificationsResponse])
                }
                setHasMore(notificationsResponse.length === 12)
                if (pageToLoad === 1) {
                    initializeNotifications(totalRead, totalUnread)
                }
            } catch (error) {
                if (error.message !== ERROR_MESSAGES_TEXT.forceUpdate && isMobileSystem) {
                    toast.error(`Notificaciones de WhatsApp: ${BFFAgent.Notifications.getRequestFailedToastMessage(error)}`)
                }
            } finally {
                setLoading(false)
            }
        },
        [getWhatsAppNotifications, showUnreadOnly, initializeNotifications]
    )

    const getCallNotifications = useCallback(
        async (pageToLoad = 1) => {
            setCallsLoading(true)
            try {
                const { notifications: callsResponse } =
                    await getWhatsAppNotifications(pageToLoad, false, WHATSAPP_CALLS_EVENT_REASONS)

                if (pageToLoad === 1) {
                    setCallNotifications(callsResponse)
                } else {
                    setCallNotifications(prev => [...prev, ...callsResponse])
                }
                setCallsHasMore(callsResponse.length === 12)
                setCallsLoaded(true)
            } catch (error) {
                if (error.message !== ERROR_MESSAGES_TEXT.forceUpdate && isMobileSystem) {
                    toast.error(`Notificaciones de WhatsApp: ${BFFAgent.Notifications.getRequestFailedToastMessage(error)}`)
                }
            } finally {
                setCallsLoading(false)
            }
        },
        [getWhatsAppNotifications]
    )

    const handleNotification = async () => {
        if (!anchorEl) setLoading(true)
        try {
            const { notifications: responseNotifications, totalRead, totalUnread } =
                await getWhatsAppNotifications(1, showUnreadOnly, WHATSAPP_MESSAGES_EVENT_REASONS)

            if (!anchorEl) {
                setNotifications(responseNotifications)
                initializeNotifications(totalRead, totalUnread)
            } else {
                setPendingData({ notifications: responseNotifications, totalRead, totalUnread })
                setForceShow(true)
                if (activeTab === WHATSAPP_TAB.CALLS) {
                    getCallNotifications(1)
                    setCallsPage(1)
                }
            }

            if (totalUnread >= unreadCount) {
                if (anchorEl) {
                    setForceShow(true)
                    setBadgeVisible(false)
                } else {
                    setBadgeVisible(true)
                }
                setBadgeCount(totalUnread)
            }
        } catch (error) {
                if (error.message !== ERROR_MESSAGES_TEXT.forceUpdate && isMobileSystem) {
                    toast.error(`Notificaciones de WhatsApp: ${BFFAgent.Notifications.getRequestFailedToastMessage(error)}`)
                }
        } finally {
            setLoading(false)
        }
    }

    const removeFocusStyles = () => {
        if (whatsappIconRef.current) {
            whatsappIconRef.current.blur()
            whatsappIconRef.current.classList.remove('Mui-focusVisible')
            const rippleElement = whatsappIconRef.current.querySelector('.MuiTouchRipple-root')
            if (rippleElement) {
                rippleElement.remove()
            }
        }
    }

    const handleClose = () => {
        setAnchorEl(null)
        removeFocusStyles()
        setShowTooltip(false)
        if (forceShow) {
            setTimeout(() => {
                setForceShow(false)
                setBadgeVisible(true)
                setNotifications(pendingData.notifications || [])
                initializeNotifications(pendingData.totalRead, pendingData.totalUnread)
            }, 400)
        }
    }

    const openWhatsAppNotifications = () => {
        if (onOpen) onOpen()
        setAnchorEl(document.getElementById('whatsapp-notification-icon'))
        setBadgeVisible(false)
        setShowTooltip(false)
        setActiveTab(WHATSAPP_TAB.MESSAGES)
        getNotifications(1, showUnreadOnly)
        setPage(1)
        setCallsLoaded(false)
        setCallNotifications([])
        setCallsPage(1)
        setCallsHasMore(true)
        if (isMobile) {
            closeSideMenu()
        }
    }

    const handleMarkAsRead = async notificationId => {
        try {
            await BFFAgent.Notifications.markAsRead(notificationId, userId)
            const notificationIndex = notifications.findIndex(
                notification => notification.id === notificationId
            )
            if (notificationIndex !== -1) {
                const updatedNotifications = [...notifications]
                updatedNotifications[notificationIndex] = {
                    ...updatedNotifications[notificationIndex],
                    read: true,
                }

                const filteredNotifications = showUnreadOnly
                    ? updatedNotifications.filter(notification => !notification.read)
                    : updatedNotifications

                setNotifications(filteredNotifications)
                setUnreadCount(unreadCount - 1)
                setBadgeCount(badgeCount - 1)

                if (unreadCount === 1) {
                    setBadgeVisible(false)
                }
            }
            setCallNotifications(prev => {
                const callIndex = prev.findIndex(notification => notification.id === notificationId)
                if (callIndex === -1) return prev
                const updatedCalls = [...prev]
                updatedCalls[callIndex] = { ...updatedCalls[callIndex], read: true }
                return updatedCalls
            })
        } catch (error) {
            toast.error('Error al marcar la notificación como leída')
        }
    }

    const handleMarkAsUnread = async notificationId => {
        try {
            await BFFAgent.Notifications.markAsUnread(notificationId, userId)
            const notificationIndex = notifications.findIndex(
                notification => notification.id === notificationId
            )
            if (notificationIndex !== -1) {
                const updatedNotifications = [...notifications]
                updatedNotifications[notificationIndex] = {
                    ...updatedNotifications[notificationIndex],
                    read: false,
                }

                setNotifications(updatedNotifications)
                setUnreadCount(unreadCount + 1)
                setBadgeCount(unreadCount + 1)
            }
            setCallNotifications(prev => {
                const callIndex = prev.findIndex(notification => notification.id === notificationId)
                if (callIndex === -1) return prev
                const updatedCalls = [...prev]
                updatedCalls[callIndex] = { ...updatedCalls[callIndex], read: false }
                return updatedCalls
            })
        } catch (error) {
            toast.error('Error al marcar la notificación como no leída')
        }
    }

    const handleSwitchChange = () => {
        const newShowUnreadOnly = !showUnreadOnly
        setShowUnreadOnly(newShowUnreadOnly)
        localStorage.setItem(SHOW_UNREAD_ONLY_KEY, newShowUnreadOnly)
        setPage(1)
        setHasMore(true)
        setNotifications([])
        getNotifications(1, newShowUnreadOnly)
    }

    const getScrollContainer = useCallback(() => {
        if (isMobile) {
            return document.querySelector('.notifications-mobile-container')
        }
        return document.getElementById('whatsapp-notifications')
    }, [isMobile])

    const handleScroll = useCallback(() => {
        const menuNode = getScrollContainer()
        if (!menuNode) return

        const { scrollTop, scrollHeight, clientHeight } = menuNode
        if (scrollHeight - scrollTop <= clientHeight + 20) {
            if (activeTab === WHATSAPP_TAB.MESSAGES) {
                if (loading || !hasMore) return
                const nextPage = page + 1
                getNotifications(nextPage, showUnreadOnly)
                setPage(nextPage)
                return
            }

            if (callsLoading || !callsHasMore) return
            const nextCallsPage = callsPage + 1
            getCallNotifications(nextCallsPage)
            setCallsPage(nextCallsPage)
        }
    }, [
        activeTab,
        loading,
        hasMore,
        page,
        getNotifications,
        showUnreadOnly,
        getScrollContainer,
        callsLoading,
        callsHasMore,
        callsPage,
        getCallNotifications,
    ])

    useEffect(() => {
        if (!hasWhatsappBusinessApi || !userId) return

        const fetchInitialCount = async () => {
            try {
                const { totalUnread } = await getWhatsAppNotifications(1, true)
                setUnreadCount(totalUnread)
                setBadgeCount(totalUnread)
            } catch (error) {
                if (error.message !== ERROR_MESSAGES_TEXT.forceUpdate && isMobileSystem) {
                    toast.error(`Notificaciones de WhatsApp: ${BFFAgent.Notifications.getRequestFailedToastMessage(error)}`)
                }
            }
        }

        fetchInitialCount()
    }, [hasWhatsappBusinessApi, userId, getWhatsAppNotifications])

    useEffect(() => {
        if (socket) {
            socket.on(SOCKET_EVENTS.NOTIFICATION, handleNotification)
            return () => {
                socket.off(SOCKET_EVENTS.NOTIFICATION, handleNotification)
            }
        }
    }, [socket, SOCKET_EVENTS, userId, unreadCount, anchorEl, showUnreadOnly, activeTab])

    useEffect(() => {
        if (!shouldUpdateNotificationsList || !hasWhatsappBusinessApi || !userId) return

        const refreshNotifications = async () => {
            try {
                const { notifications: responseNotifications, totalRead, totalUnread } =
                    await getWhatsAppNotifications(1, showUnreadOnly, WHATSAPP_MESSAGES_EVENT_REASONS)
                dispatch(updateNotificationsList(false))
                setNotifications(responseNotifications)
                initializeNotifications(totalRead, totalUnread)
                if ((totalUnread > unreadCount || totalUnread === unreadCount) && !anchorEl) {
                    setBadgeVisible(true)
                    setBadgeCount(totalUnread)
                }
                if (activeTab === WHATSAPP_TAB.CALLS) {
                    getCallNotifications(1)
                    setCallsPage(1)
                }
            } catch (error) {
                if (error.message !== ERROR_MESSAGES_TEXT.forceUpdate && isMobileSystem) {
                    toast.error(`Notificaciones de WhatsApp: ${BFFAgent.Notifications.getRequestFailedToastMessage(error)}`)
                }
            }
        }

        refreshNotifications()
    }, [shouldUpdateNotificationsList])

    useEffect(() => {
        const menuNode = getScrollContainer()
        if (menuNode && anchorEl) {
            menuNode.addEventListener('scroll', handleScroll)
        }
        return () => {
            if (menuNode) {
                menuNode.removeEventListener('scroll', handleScroll)
            }
        }
    }, [handleScroll, anchorEl, getScrollContainer])

    useEffect(() => {
        const handleEscKey = event => {
            if (event.key === 'Escape' && anchorEl) {
                handleClose()
            }
        }

        document.addEventListener('keydown', handleEscKey)
        return () => {
            document.removeEventListener('keydown', handleEscKey)
        }
    }, [anchorEl])

    if (!hasWhatsappBusinessApi) {
        return null
    }

    const handleClick = () => {
        if (anchorEl) {
            handleClose()
        } else {
            openWhatsAppNotifications()
        }
    }

    const handleTabChange = (_event, newValue) => {
        setActiveTab(newValue)
        if (newValue === WHATSAPP_TAB.CALLS && !callsLoaded && !callsLoading) {
            getCallNotifications(1)
            setCallsPage(1)
        }
    }

    const renderEmptyNotifications = () => {
        const allReadMessage = (
            <>
                <EmptyNotificationsIcon />
                <div className="empty-state-title">Estás al día</div>
                <div className="empty-state-text">
                    Ya leíste todas las notificaciones de los últimos 15 días
                </div>
            </>
        )

        const emptyMessage = (
            <>
                <img src={emptyBox} alt="Imagen por defecto" />
                <div className="empty-state-title">Aún no tenés notificaciones</div>
                <div className="empty-state-text">
                    {showUnreadOnly
                        ? EMPTY_NOTIFICATIONS_MESSAGE_UNREAD
                        : EMPTY_NOTIFICATIONS_MESSAGE_ALL}
                </div>
            </>
        )

        return (
            <div className="empty-state-notification">
                {readCount === 0 ? emptyMessage : allReadMessage}
            </div>
        )
    }

    const renderCallsTabContent = () => (
        <>
            <div className="notification-list whatsapp-calls-list">
                {callsLoading && callsPage === 1 ? (
                    <div className="loading-state-notification">
                        <div className="spinner">
                            <Spinner colorIcon="#6c63ff" centered={true} />
                        </div>
                        <div className="loading-text">Cargando notificaciones...</div>
                    </div>
                ) : callNotifications.length ? (
                    callNotifications.map(notification => (
                        <CallNotificationItem
                            key={notification.id}
                            notification={notification}
                            onMarkAsRead={handleMarkAsRead}
                            closeMenu={handleClose}
                        />
                    ))
                ) : (
                    <div className="empty-state-notification">
                        <img src={emptyBox} alt="Imagen por defecto" />
                        <div className="empty-state-title">Aún no tenés notificaciones</div>
                        <div className="empty-state-text">
                            Cuando tengas nuevas las verás acá
                        </div>
                    </div>
                )}
            </div>

            {callNotifications.length > 0 && !callsLoading && !callsHasMore && (
                <>
                    <hr className="notification-divider" />
                    <div className="notification-footer">
                        <CheckIcon />
                        <span>Estas son todas las llamadas de los últimos 15 días</span>
                    </div>
                </>
            )}
            {callsLoading && callsPage > 1 && (
                <div className="loading-more">
                    <Spinner colorIcon="#6c63ff" centered={true} />
                </div>
            )}
        </>
    )

    const renderMessagesTabContent = () => (
        <>
            <div className="notification-list">
                {loading && page === 1 ? (
                    <div className="loading-state-notification">
                        <div className="spinner">
                            <Spinner colorIcon="#6c63ff" centered={true} />
                        </div>
                        <div className="loading-text">Cargando notificaciones...</div>
                    </div>
                ) : notifications.length ? (
                    notifications.map(notification => (
                        <NotificationItem
                            key={notification.id}
                            notification={notification}
                            onMarkAsRead={handleMarkAsRead}
                            onMarkAsUnread={handleMarkAsUnread}
                            closeMenu={handleClose}
                        />
                    ))
                ) : (
                    renderEmptyNotifications()
                )}
            </div>

            {notifications.length > 0 && !loading && !hasMore && (
                <>
                    <hr className="notification-divider" />
                    <div className="notification-footer">
                        <CheckIcon />
                        <span>
                            Estas son todas las notificaciones{' '}
                            {showUnreadOnly ? <b>no leídas </b> : ''}
                            de los últimos 15 días
                        </span>
                    </div>
                </>
            )}
            {loading && page > 1 && (
                <div className="loading-more">
                    <Spinner colorIcon="#6c63ff" centered={true} />
                </div>
            )}
        </>
    )

    const renderPanelContent = () => (
        <div className="whatsapp-notification-panel">
            <div className="whatsapp-notification-header">
                {!isMobile && (
                    <span className="title-notification">Notificaciones de WhatsApp</span>
                )}
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    className="whatsapp-notification-tabs"
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="Mensajes" value={WHATSAPP_TAB.MESSAGES} />
                    <Tab label="Llamadas" value={WHATSAPP_TAB.CALLS} />
                </Tabs>
                {activeTab === WHATSAPP_TAB.MESSAGES && (
                    <div className="whatsapp-notification-filter-row">
                        <div className="notification-filter">
                            <span>Mostrar sólo las no leídas</span>
                            <Switch
                                checked={showUnreadOnly}
                                onChange={handleSwitchChange}
                                color="primary"
                                disabled={loading}
                            />
                        </div>
                    </div>
                )}
            </div>
            {activeTab === WHATSAPP_TAB.MESSAGES
                ? renderMessagesTabContent()
                : renderCallsTabContent()}
        </div>
    )

    return (
        <div className="home-whatsapp-notification-menu">
            <Tooltip
                title={TOOLTIP_TEXT}
                placement="bottom"
                arrow
                open={showTooltip && !anchorEl}
                disableHoverListener
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
            >
                <IconButton
                    ref={whatsappIconRef}
                    color="inherit"
                    onClick={handleClick}
                    id="whatsapp-notification-icon"
                >
                    {badgeVisible && badgeCount > 0 ? (
                        <Badge
                            badgeContent={badgeCount > 9 ? '9+' : badgeCount}
                            color="error"
                        >
                            <WhatsAppIcon className="whatsapp-notification-icon" />
                        </Badge>
                    ) : (
                        <WhatsAppIcon className="whatsapp-notification-icon" />
                    )}
                </IconButton>
            </Tooltip>
            {Boolean(anchorEl) &&
                (isMobile ? (
                    <ConfirmationModal
                        title="Notificaciones de WhatsApp"
                        overlayClassName="notifications-mobile-container"
                        className="notifications-mobile-inner-container"
                        footerClassName="mobile-footer"
                        onClose={handleClose}
                    >
                        {renderPanelContent()}
                    </ConfirmationModal>
                ) : (
                    <StyledMenu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        {renderPanelContent()}
                    </StyledMenu>
                ))}
        </div>
    )
}

export default WhatsAppNotificationMenu
